import { EWalletTypeEnum, PaymentType } from '../enums';

export const convertPaymentType: Partial<Record<PaymentType, EWalletTypeEnum>> = {
    [PaymentType.Mpos]: EWalletTypeEnum.MPOS_NEW,
    [PaymentType.ACB]: EWalletTypeEnum.VIETQR_ACB,
    [PaymentType.Uni]: EWalletTypeEnum.UNI_SERVICE,
    [PaymentType.Eximbank]: EWalletTypeEnum.EXIMBANK,
    [PaymentType.Bidv]: EWalletTypeEnum.BIDV
};
